import { render } from "./AddMeldingView.vue?vue&type=template&id=187f7350&scoped=true"
import script from "./AddMeldingView.vue?vue&type=script&lang=js"
export * from "./AddMeldingView.vue?vue&type=script&lang=js"

import "./AddMeldingView.vue?vue&type=style&index=0&id=187f7350&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-187f7350"]])

export default __exports__